import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class SStaffIndicationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      designation_id: null,
      aircraft_model_id: null,
      date_start: '',
      staff_indications: [],
      aircraft_models: [],
      designations: [],
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.activate = this.activate.bind(this);
    this.delete = this.delete.bind(this);
    this.archive = this.archive.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.designations) && Array.isArray(newProps.aircraft_models) && Array.isArray(newProps.staff_indications) && this.state.loaded === false) {
      this.setState({
        aircraft_models: newProps.aircraft_models,
        designations: newProps.designations,
        staff_indications: newProps.staff_indications,
        loaded: true
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      designation_id: this.state.designation_id,
      aircraft_model_id: this.state.aircraft_model_id,
      date_start: this.state.date_start,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/indicacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.refreshData();
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Fetch ativando um item
  activate(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.ativar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/indicacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  // Fetch deletando um item
  archive(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.arquivar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/indicacao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  // Fetch deletando um item
  delete(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/indicacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  refreshData () {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/indicacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_indications: responseJson.data});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tituloIndicacao}</h3>
  <hr/>
  {(this.state.staff_indications === null || typeof this.state.staff_indications === 'undefined') ?  <div><small><em>{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.nenhumaIndicacaoCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Designacao}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Frota}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Status}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Data}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_indications).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_indications[k].designation}</td>
              <td className="text-center">{self.state.staff_indications[k].aircraft_model}</td>
              <td className="text-center">{(self.state.staff_indications[k].active === 1) ?  <span className="label label-success">{self.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tabela.Arquivado}</span>}</td>
              <td className="text-center">{self.state.staff_indications[k].date_start_str}</td>
              <td className="text-center">
                {(self.state.staff_indications[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_indications[k].id} onClick={self.archive}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_indications[k].id} onClick={self.activate}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-danger" value={self.state.staff_indications[k].id} onClick={self.delete}>
                  <i className="fa fa-fw fa-trash"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tituloCadastrarIndicacao}</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.formulario.Designacao}:</label>
        <Select
          className="form-field-name"
          name="designation_id"
          value={this.state.designation_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'designation_id')}
          options={this.state.designations}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.formulario.Validade}:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.formulario.Frota}:</label>
        <Select
          className="form-field-name"
          name="aircraft_model_id"
          value={this.state.aircraft_model_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
          options={this.state.aircraft_models}
        />    
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.formulario.botaoSalvarIndicacao}</button>
  </form>
</div>
    );
  }
}

export default SStaffIndicationsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffIndicationsTab.js